import type { BuyRequest, Product } from '@/js/services/RogueTypes'

export type StockStatus = '' | 'bin' | 'oos'

function forProduct(product: Product): StockStatus {
  if (!product || !product.inventory) {
    return 'oos'
  }

  if (product.inventory.max === 0) {
    return product.inventory.bin ? 'bin' : 'oos'
  }

  return ''
}

function forBuyRequest(buyRequest: BuyRequest, products: Record<number, Product>): StockStatus {
  if (!buyRequest || !buyRequest.productId) {
    return ''
  }
  const product = products[buyRequest.productId]

  if (!product) {
    return ''
  }

  if (product.type === 'simple') {
    return forProduct(product)
  }

  if (product.type === 'configurable') {
    const child = buyRequest.children ? buyRequest.children[0] : undefined
    if (child) {
      return forProduct(products[child.productId])
    }

    return ''
  }

  if (product.type === 'bundle') {
    const bundleBuyRequestItems = buyRequest.children?.filter(child => child.metadata?.bundleOptionId)
    const statuses = product.bundleOptions!
      .filter(option => bundleBuyRequestItems?.find(child => child.metadata?.bundleOptionId === option.id))
      .map(option => buyRequest.children?.find(child => child.metadata?.bundleOptionId === option.id))
      .map(child => (!child ? 'oos' : forBuyRequest(child, products)))

    if (statuses.indexOf('oos') !== -1) {
      return 'oos'
    }
    if (statuses.indexOf('bin') !== -1) {
      return 'bin'
    }

    return ''
  }

  if (product.type === 'grouped') {
    if (!buyRequest.children) {
      return ''
    }

    const hasQty = buyRequest.children.filter(child => child.qty > 0)

    if (hasQty.length === 0) {
      return forBuyRequest(buyRequest.children[0], products)
    }

    const statuses: StockStatus[] = hasQty
      .map(childBuyRequest => forBuyRequest(childBuyRequest, products))

    if (statuses.some(s => s === '')) {
      return ''
    }

    return statuses[0]
  }

  return ''
}

export default {
  forProduct,
  forBuyRequest,
}
